import React, { useState, useEffect } from "react";
import {
  StyledTable,
  StyledHead,
  StyledHeadCell,
  StyledBody,
  StyledRow,
  StyledCell,
} from "baseui/table";
import { styled } from "baseui";
import { Button } from "baseui/button";
import { Search } from "baseui/icon";
import { StatefulInput } from "baseui/input";

// Define log level colors
const LOG_LEVEL_COLORS = {
  ERROR: "#FFD3D3",
  WARN: "#FFF2D3",
  INFO: "#D3E3FF",
  DEBUG: "#E3FFD3",
  SUCCESS: "#D3FFD9",
  DEFAULT: "#FFFFFF",
};

// Styled components
const LogContainer = styled("div", {
  height: "600px",
  overflowY: "auto",
  border: "1px solid #EEE",
  borderRadius: "4px",
  margin: "16px 0",
});

const LogMessage = styled("div", {
  fontFamily: "monospace",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
});

const LogLevel = styled("div", ({ $level }) => ({
  padding: "4px 8px",
  borderRadius: "4px",
  backgroundColor: LOG_LEVEL_COLORS[$level] || LOG_LEVEL_COLORS.default,
  textTransform: "uppercase",
  fontWeight: "bold",
  fontSize: "0.75rem",
  display: "inline-block",
}));

const Controls = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "16px",
  gap: "16px",
});

const LogViewer = ({ logs }) => {
  const [filter, setFilter] = useState("");

  // Filter only by level and message
  const filteredLogs = logs.filter(
    (log) =>
      log.message.toLowerCase().includes(filter.toLowerCase()) ||
      log.logLevel.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div>
      <LogContainer>
        <StyledTable>
          <StyledHead>
            <StyledHeadCell>Time</StyledHeadCell>
            <StyledHeadCell>Level</StyledHeadCell>
            <StyledHeadCell>Message</StyledHeadCell>
          </StyledHead>
          <StyledBody>
            {logs.map((log) => (
              <StyledRow key={log.message}>
                <StyledCell>
                  {new Date(log.timestamp).toLocaleTimeString()}
                </StyledCell>
                <StyledCell>
                  <LogLevel $level={log.logLevel}>{log.logLevel}</LogLevel>
                </StyledCell>
                <StyledCell>
                  <LogMessage>{log.message}</LogMessage>
                </StyledCell>
              </StyledRow>
            ))}
          </StyledBody>
        </StyledTable>
      </LogContainer>
    </div>
  );
};

export default LogViewer;
